import { MgService } from 'src/app/services/mg.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-user-business-selection-responsive',
  templateUrl: './user-business-selection-responsive.component.html',
  styleUrls: ['./user-business-selection-responsive.component.scss']
})
export class UserBusinessSelectionResponsiveComponent implements OnInit {
  @Input() users: any;
  @Output() selectUserBusiness = new EventEmitter<any>();
  constructor(
    public api: MgService
  ) { }

  ngOnInit(): void {
  }

  public selectUser(user: any) {
    this.selectUserBusiness.emit(user);
  }
}
